<template>
  <div>
    <Header></Header>
    <div class="wrapper">
      <div class="top">
        <p class="col-12 top-nav text-left">
          <span class="index">首页</span>
          <span>&gt;</span>
          <span class="second">资讯动态</span>
        </p>
      </div>
      <div class="list-award">
        <div class="each">
          <a href="/#/NewsDetail?id=10">
            <div class="row">
              <div class="col-md-2 col-3">
                <p class="left-date text-left">10-26</p>
                <p class="left-year text-left">2019</p>
                <p class="left-arrow">
                  <img src="../img/news/news-arrow.png" alt />
                </p>
                <!--<p><i class="glyphicon glyphicon-right"></i></p>-->
              </div>
              <div class="col-md-6 col-7">
                <p class="award-title text-left">全员齐动，稳中求进——2019及时雨小贷团建</p>
                <p class="award-subtitle text-left">2019年10月26日，及时雨小贷团队建设活动！</p>
              </div>
              <div class="col-md-4 rightPic">
                <img src="../img/news/10.png" height="150px" width="286px" alt />
              </div>
            </div>
          </a>
        </div>

        <div class="each">
          <a href="/#/NewsDetail?id=1">
            <div class="row">
              <div class="col-md-2 col-3">
                <p class="left-date text-left">08-08</p>
                <p class="left-year text-left">2019</p>
                <p class="left-arrow">
                  <img src="../img/news/news-arrow.png" alt />
                </p>
              </div>
              <div class="col-md-6 col-7">
                <p class="award-title text-left">年中复盘，继往开来丨及时雨小贷半年度工作总结</p>
                <p class="award-subtitle text-left">7月31日，及时雨高管团队20余人，齐聚新疆乌鲁木齐，召开半年度工作会议。</p>
              </div>
              <div class="col-md-4 rightPic">
                <img src="../img/news/01.png" height="150px" alt />
              </div>
            </div>
          </a>
        </div>

        <div class="each">
          <a href="/#/NewsDetail?id=9">
            <div class="row">
              <div class="col-md-2 col-3">
                <p class="left-date text-left">03-31</p>
                <p class="left-year text-left">2019</p>
                <p class="left-arrow">
                  <img src="../img/news/news-arrow.png" alt />
                </p>
                <!--<p><i class="glyphicon glyphicon-right"></i></p>-->
              </div>
              <div class="col-md-6 col-7">
                <p class="award-title text-left">及时雨小贷创始人宋梅受邀出席第七届“在沪女企业家峰会”！</p>
                <p class="award-subtitle text-left">3月31日，“巾帼荣耀，星闪浦江——第七届十八省在沪商会女企业家峰会”成功举行。</p>
              </div>
              <div class="col-md-4 rightPic">
                <img src="../img/news/09.png" height="150px" width="286px" alt />
              </div>
            </div>
          </a>
        </div>

        <div class="each">
          <a href="/#/NewsDetail?id=2">
            <div class="row">
              <div class="col-md-2 col-3">
                <p class="left-date text-left">03-12</p>
                <p class="left-year text-left">2019</p>
                <p class="left-arrow">
                  <img src="../img/news/news-arrow.png" alt />
                </p>
                <!--<p><i class="glyphicon glyphicon-right"></i></p>-->
              </div>
              <div class="col-md-6 col-7">
                <p class="award-title text-left">周年庆丨六年风雨同行 共谱美好篇章</p>
                <p
                  class="award-subtitle text-left"
                >2013年3月8日，及时雨小贷经上海市政府批准成立。时光流逝，转眼到了2019年3月8日，及时雨小贷6岁了。</p>
              </div>
              <div class="col-md-4 rightPic">
                <img src="../img/news/02.png" height="150px" alt />
              </div>
            </div>
          </a>
        </div>

        <div class="each">
          <a href="/#/NewsDetail?id=3">
            <div class="row">
              <div class="col-md-2 col-3">
                <p class="left-date text-left">01-17</p>
                <p class="left-year text-left">2019</p>
                <p class="left-arrow">
                  <img src="../img/news/news-arrow.png" alt />
                </p>
                <!--<p><i class="glyphicon glyphicon-right"></i></p>-->
              </div>
              <div class="col-md-6 col-7">
                <p class="award-title text-left">喜报！上海及时雨小贷斩获“全国优秀小贷”荣誉</p>
                <p class="award-subtitle text-left">未来，及时雨小贷将再接再厉，继续积极发挥优秀典型示范作用！</p>
              </div>
              <div class="col-md-4 rightPic">
                <img src="../img/news/03.png" height="150px" alt />
              </div>
            </div>
          </a>
        </div>

        <div class="each">
          <a href="/#/NewsDetail?id=4">
            <div class="row">
              <div class="col-md-2 col-3">
                <p class="left-date text-left">10-25</p>
                <p class="left-year text-left">2018</p>
                <p class="left-arrow">
                  <img src="../img/news/news-arrow.png" alt />
                </p>
                <!--<p><i class="glyphicon glyphicon-right"></i></p>-->
              </div>
              <div class="col-md-6 col-7">
                <p class="award-title text-left">四川小贷行业考察团莅临及时雨小贷公司参观交流</p>
                <p class="award-subtitle text-left">2018年10月25日，四川小贷行业考察团队莅临及时雨小贷公司参观交流。</p>
              </div>
              <div class="col-md-4 rightPic">
                <img src="../img/news/04.png" height="150px" alt />
              </div>
            </div>
          </a>
        </div>

        <div class="each">
          <a href="/#/NewsDetail?id=5">
            <div class="row">
              <div class="col-md-2 col-3">
                <p class="left-date text-left">04-04</p>
                <p class="left-year text-left">2018</p>
                <p class="left-arrow">
                  <img src="../img/news/news-arrow.png" alt />
                </p>
                <!--<p><i class="glyphicon glyphicon-right"></i></p>-->
              </div>
              <div class="col-md-6 col-7">
                <p class="award-title text-left">重磅：上海小贷行业完成首单同业拆借</p>
                <p class="award-subtitle text-left">2018年4月3日，上海小贷行业首单同业拆借签约仪式在上海嘉定及时雨小额贷款股份有限公司举行。</p>
              </div>
              <div class="col-md-4 rightPic">
                <img src="../img/news/05.png" height="150px" alt />
              </div>
            </div>
          </a>
        </div>

        <div class="each">
          <a href="/#/NewsDetail?id=6">
            <div class="row">
              <div class="col-md-2 col-3">
                <p class="left-date text-left">03-09</p>
                <p class="left-year text-left">2017</p>
                <p class="left-arrow">
                  <img src="../img/news/news-arrow.png" alt />
                </p>
                <!--<p><i class="glyphicon glyphicon-right"></i></p>-->
              </div>
              <div class="col-md-6 col-7">
                <p class="award-title text-left">周年庆丨吃的很好，玩得很嗨！</p>
                <p class="award-subtitle text-left">及时雨成立的4年来，不断积聚能量，不断成长，所有及时雨人共同努力成就今日的“绿意盎然”！</p>
              </div>
              <div class="col-md-4 rightPic">
                <img src="../img/news/06.png" height="150px" alt />
              </div>
            </div>
          </a>
        </div>

        <div class="each">
          <a href="/#/NewsDetail?id=7">
            <div class="row">
              <div class="col-md-2 col-3">
                <p class="left-date text-left">01-11</p>
                <p class="left-year text-left">2017</p>
                <p class="left-arrow">
                  <img src="../img/news/news-arrow.png" alt />
                </p>
                <!--<p><i class="glyphicon glyphicon-right"></i></p>-->
              </div>
              <div class="col-md-6 col-7">
                <p class="award-title text-left">及时雨尹君：科技创新打造小微金融“小时代”</p>
                <p class="award-subtitle text-left">在各领域，科技都在推动我们做改变、做创新。如果不变，你可能要面临被淘汰。</p>
              </div>
              <div class="col-md-4 rightPic">
                <img src="../img/news/07.png" height="150px" alt />
              </div>
            </div>
          </a>
        </div>

        <div class="each">
          <a href="/#/NewsDetail?id=8">
            <div class="row">
              <div class="col-md-2 col-3">
                <p class="left-date text-left">04-09</p>
                <p class="left-year text-left">2016</p>
                <p class="left-arrow">
                  <img src="../img/news/news-arrow.png" alt />
                </p>
                <!--<p><i class="glyphicon glyphicon-right"></i></p>-->
              </div>
              <div class="col-md-6 col-7">
                <p class="award-title text-left">及时雨小贷宋梅荣获“2015中国小微金融年度人物”称号</p>
                <p
                  class="award-subtitle text-left"
                >2016年4月9日， 第六届中国小微金融机构联席会年会在北京召开。及时雨小贷宋梅荣获“2015中国小微金融年度人物”荣誉称号。</p>
              </div>
              <div class="col-md-4 rightPic">
                <img src="../img/news/08.png" height="150px" width="286px" alt />
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "./Header";
import Footer from "./Footer";

export default {
  name: "News",
  components: { Header, Footer }
};
</script>

<style scoped lang="less">
p {
  margin: 0;
}
a:hover {
  text-decoration: none;
}

//pc、laptop
@media screen and (min-width: 769px) {
  .top,
  .list-award .each {
    width: 1300px !important;
  }
  .each {
    .rightPic {
      img {
        height: 130px;
      }
    }
  }
  .award-title {
    font-size: 20px;
  }
}

//phone
@media screen and (max-width: 768px) {
  .wrapper {
    padding-top: 90px;
  }
  .each {
    .rightPic {
      display: none !important;
      img {
        width: 90%;
      }
    }
  }
  .award-title {
    margin-top: 10px !important;
    font-size: 30px;
  }
  .award-subtitle {
    font-size: 26px;
  }
  .top {
    font-size: 26px;
  }
}

.top {
  margin: 60px auto 48px;
  padding-left: 50px;

  .top-nav {
    margin-bottom: 48px;

    .index {
      margin-right: 10px;
      color: #01a494;
    }
    .second {
      margin-left: 10px;
    }
  }
}

.list-award {
  margin-top: 89px;
  margin-bottom: 300px;

  .each {
    height: 250px;
    margin: 0 auto 72px;
    padding-left: 50px;

    .row {
      margin: 0 auto;

      height: 100%;

      .rightPic {
        align-items: center;
        display: flex;
        justify-content: center;
      }
    }

    .left-date,
    .left-year,
    .award-title {
      color: #35383d;
    }
    .left-date {
      font-size: 40px;
      /*margin-top:14px;*/
    }
    .left-year {
      padding-left: 10px;
      margin-bottom: 15px;
    }
    .left-arrow {
      padding-left: 5px;
      text-align: left;
    }
    .award-title {
      margin: 20px 0 37px;
      font-weight: bold;
    }
    .award-subtitle {
      color: #696d71;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/News.vue